<template>
  <div class="nav-wrap">
    <div class="nav-inner clear">
      <img :src="url"/>
      <nav ref="nav" class="right">
        <router-link to="/"><span @click="changeIndex(0)">首页</span></router-link>
        <router-link to="/"><span @click="changeIndex(1)">生态</span></router-link>
        <router-link to="/"><span @click="changeIndex(2)">产品</span></router-link>
        <router-link to="/"><span @click="changeIndex(3)">服务</span></router-link>
        <router-link to="/"><span @click="changeIndex(4)">案例</span></router-link>
        <router-link to="/"><span @click="changeIndex(5)">关于我们</span></router-link>
      </nav>
    </div>
  </div>
</template>

<script>
  import bus from '../../assets/js/bus';

  export default {
    name: "v-nav",
    props: ['url', 'color', 'showIndex', 'changeMethods'],
    mounted() {
      this.$refs.nav.style.color = this.color;
    },
    methods: {
      changeIndex(showIndex) {
        bus.showIndex = showIndex;
        if (this.changeMethods) {
          //主页面点击导航则出发
          bus.$emit('showIndexChange');
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../../assets/less/base";

  .nav-wrap {
    padding: 2rem 0;
    .nav-inner {
      width: 72%;
      min-width: 1180px;
      margin: auto;
      img {
        display: block;
        float: left;
      }
      nav {
        float: right;
        font-size: 1.25rem;
        line-height: 40px;
        a {
          position: relative;
          margin-right: 3rem;
          cursor: pointer;
        }
        a:last-of-type {
          margin-right: 0;
        }
        a:hover {
          color: #0AD3FD;
        }
        a:hover::after {
          content: '';
          display: block;
          position: absolute;
          width: 10px;
          height: 0;
          bottom: -5px;
          left: calc(~'50% - 5px');
          border-bottom: 1px solid #0AD3FD;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/plug/Nav.vue